import { TFunction } from "i18next";
import { z } from "zod";
import { chargepointDefaultValues, chargepointSchema } from "./chargepoint";
import { companyDefaultValues, companySchema } from "./company";
import { installationDefaultValues, installationSchema } from "./installation";
import { siteDefaultValues, siteSchema } from "./site";
import { teamDefaultValues, teamSchema } from "./team";

export type Tier = "basic" | "commercial";
export const tiers: Tier[] = ["basic", "commercial"];

export const onboardingSchema = (t: TFunction) => {
  return z
    .object({
      tier: z.enum(["basic", "commercial"]),
      chargepoint: z.array(chargepointSchema(t)),
      company: companySchema(t),
      team: teamSchema(t),
      site: siteSchema(t),
      installation: installationSchema(t),
    })
    // .refine(
    //   (data) => {
    //     return !(data.tier !== "sponsored" && !data.team.name);
    //   },
    //   {
    //     message: "",
    //     path: ["team.name"],
    //   }
    // )
    // .refine(
    //   (data) => {
    //     return !(data.tier === "sponsored" && !data.company.taxID);
    //   },
    //   {
    //   message: "",
    //     path: ["company.taxID"],
    //   }
    // )
    // .refine(
    //   (data) => {
    //     return !(data.tier === "sponsored" && !data.team.employee);
    //   },
    //   {
    //     message: "",
    //     path: ["team.employee.name"],
    //   }
    // )
    // .refine(
    //   (data) => {
    //     return !(
    //       data.tier === "sponsored" &&
    //       data.team.employee &&
    //       (data.team.owner.email === data.team.employee.email ||
    //         data.team.finance.email === data.team.employee.email)
    //     );
    //   },
    //   {
    //     message: t("Email address is already in use"),
    //     path: ["team.employee.email"],
    //   }
    // );
};

export type OnboardingType = z.infer<ReturnType<typeof onboardingSchema>>;

export const onboardingDefaultValues: OnboardingType = {
  tier: "basic",
  chargepoint: [chargepointDefaultValues],
  company: companyDefaultValues,
  team: teamDefaultValues,
  site: siteDefaultValues,
  installation: installationDefaultValues,
};
